'use client'

import type { BaseSyntheticEvent, ReactNode } from 'react'
import {
	type FieldValues,
	FormProvider,
	type SubmitErrorHandler,
	type UseFormReturn,
} from 'react-hook-form'
import { cn } from '@/lib/styles'

interface Props<T extends FieldValues = FieldValues> {
	readonly form: UseFormReturn<T>
	readonly onSubmit: (
		// eslint-disable-next-line no-unused-vars
		values: T,
		// eslint-disable-next-line no-unused-vars
		e?: BaseSyntheticEvent<object, unknown, unknown> | undefined,
	) => void
	readonly onError?: SubmitErrorHandler<T>
	readonly children: ReactNode
	readonly className?: string
	readonly fieldsetClassname?: string
	readonly id?: string
	readonly disabled?: boolean
}

export function AppForm<T extends FieldValues = FieldValues>({
	onSubmit,
	onError = () => {},
	children,
	className,
	fieldsetClassname,
	id,
	form,
	disabled,
}: Props<T>) {
	const { handleSubmit } = form

	return (
		<FormProvider {...form}>
			<form onSubmit={handleSubmit(onSubmit, onError)} className={className} id={id} noValidate>
				<fieldset
					disabled={disabled}
					className={cn(fieldsetClassname ? fieldsetClassname : 'space-y-4')}
				>
					{children}
				</fieldset>
			</form>
		</FormProvider>
	)
}
